export const baseColors = {
    "--color-white": "#ffffff",
    "--color-gray-50": "#f5f6f8",
    "--color-gray-100": "#ebeef1",
    "--color-gray-200": "#d8dee4",
    "--color-gray-300": "#b6c0cc",
    "--color-gray-400": "#9aa5b8",
    "--color-gray-500": "#818da0",
    "--color-gray-600": "#6c7688",
    "--color-gray-700": "#596171",
    "--color-gray-800": "#474f5a",
    "--color-gray-900": "#343a44",
    "--color-gray-950": "#20242c",
    "--box-shadow":
        "0 0 0 1px rgba(32, 36, 44, 0.05), 0 2px 5px 0 rgba(32, 36, 44, 0.05), 0 1px 2.5px 0 rgba(32, 36, 44, 0.05), 0 1px 2px 0 rgba(32, 36, 44, 0.05)",
    "--box-shadow-button":
        "rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.12) 0px 1px 1px 0px, rgba(32, 36, 44, 0.16) 0px 0px 0px 1px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(32, 36, 44, 0.08) 0px 2px 5px 0px",
    "--box-shadow-button-focus": "rgba(0, 0, 0, 0.08) 0px 1px 1px 0px, rgba(32, 36, 44, 0.11) 0px 0px 0px 1px, rgba(32, 36, 44, 0.1) 0px 0px 0px 4px",
    "--box-shadow-box": "0 40px 90px rgba(32, 36, 44, 0.11), 0 15px 35px rgba(32, 36, 44, 0.15), 0 1px 15px rgba(32, 36, 44, 0.1)",
    "--box-shadow-box-light": "0 35px 80px rgba(32, 36, 44, 0.07), 0 13px 30px rgba(32, 36, 44, 0.09), 0 1px 13px rgba(32, 36, 44, 0.07)",
    "--box-shadow-box-extra-light": "0 15px 70px rgba(32, 36, 44, 0.04), 0 2px 9px rgba(32, 36, 44, 0.04)",
    "--box-shadow-card": "0 0 0 1px rgba(32, 36, 44, 0.01), 0 7px 14px 0 rgba(32, 36, 44, 0.1), 0 3px 6px 0 rgba(0, 0, 0, 0.02)",
} as any;
